import { TBaseSerie } from "@/components/ui/chart/types/common-series.type";
import { EDataUnit } from "@/constants/data-units.type";
import { isDefined } from "@/utils/object";
import { EPrefixSymbol, getMaybeValuePrefixSymbol } from "@/utils/translation-utils";

export function getWhSeriesHighestPrefixSymbol(series?: TBaseSerie[]): EPrefixSymbol | undefined {
  if (!series) return;

  const allWhValues: number[] = series
    .filter((serie) => serie.unit === EDataUnit.WATT_HOUR)
    .flatMap((serie) => serie.value.map((pt) => pt.value as number))
    .filter((pt) => isDefined(pt));

  const highestValue = Math.max(...allWhValues);

  return getMaybeValuePrefixSymbol(highestValue);
}
